
import axios from "axios"

// TODO: add action to impersonate a user

export function fetchTeams() {
  return axios({
    method: "get",
    url: `/api/v2/teams?all`
  })
}


export const fetchTeamUsers = async (team_id) => {
  return axios({
    method: 'get',
    url: `/api/v2/teams/${team_id}/users`
  })
}